import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20.019}
    height="6.9mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20853 27166"
    {...props}
  >
    <path
      d="M16243 15506c721-2971 1299-4034 1623-6399 322-2365-2265-2581-2130-701l507 7100zm-6039 5145V8694c0-505-413-917-917-917s-917 413-917 917v11957c0 504 413 917 917 917 505 0 917-412 917-917zm-7297 6318h12760c505 0 917-413 917-917 0-505-412-917-917-917l-12760-1c-505 0-917 413-917 918 0 504 412 917 917 917zM9287 197c2606 0 4751 1094 5031 2499H4257C4537 1290 6682 197 9287 197zm6776 3746c1434 0 2672 460 3678 1797 1006 1336 1134 3429 620 5179-604 2060-1403 4465-2249 7013-374 1125-868 2251-1224 3432h1500c433 0 787 354 787 787 0 432-354 786-787 786h-1893c-206 646-633 1127-1327 1127H3407c-779 0-1465-639-1417-1417l914-14754L361 3943h15702z"
      style={{
        // fill: "#fefefe",
        // stroke: "#2b2a29",
        strokeWidth: 393.704,
      }}
      className="fill-none stroke1"
    />
  </svg>
);
export default SvgComponent;
